import React from "react";
import { Link } from "react-router-dom";
import { LayoutDashboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LandingNav } from "@/components/landing/LandingNav";
import { Hero } from "@/components/landing/Hero";
import { ProductPreview } from "@/components/landing/ProductPreview";
import { Features } from "@/components/landing/Features";
import { Pricing } from "@/components/landing/Pricing";
import { Faq } from "@/components/landing/Faq";
import { CtaBanner, LandingFooter } from "@/components/landing/CtaBanner";

export default function Landing() {
  const { user } = useAuth();
  const home = user?.role === "client" ? "/portal"
    : user?.role === "platform_owner" ? "/platform" : "/dashboard";

  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      {user && (
        <div data-testid="landing-signed-in-banner" className="bg-navy px-4 py-2.5 text-center sm:px-6">
          <Link
            to={home}
            data-testid="landing-goto-dashboard"
            className="inline-flex items-center gap-2 text-sm text-white hover:text-gold"
          >
            <LayoutDashboard className="h-4 w-4 text-gold" />
            Welcome back, {user.name?.split(" ").slice(-1)[0] || "Advocate"} — go to your dashboard
          </Link>
        </div>
      )}
      <LandingNav />
      <main>
        <Hero />
        <ProductPreview />
        <Features />
        <Pricing />
        <Faq />
        <CtaBanner />
      </main>
      <LandingFooter />
    </div>
  );
}
